import {styled} from "@mui/material";

export const NotificationsContainer = styled('div')(() => {
    return {
        padding: '1rem',
        marginBottom: '125px',
    }
});
